import "../../../field.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.VisitStep ??= {};

AppointmentBooking.Wizard.Views.VisitStep.VisitTypeRulesField = class VisitTypeRulesField extends (
  AppointmentBooking.Wizard.Views.Field
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.contextForRender = this.contextForRender.bind(this);
  }

  initialize() {
    super.initialize(...arguments);

    return this.listenTo(this.model, "change:visit_type_id relational:change:visit_type_rule_selections", this.render);
  }

  contextForRender() {
    return {
      availableRules: this.model.getSelectedVisitTypeRules(),
      visit_type_rule_selections: this.model.get("visit_type_rule_selections").toJSON(),
    };
  }
};
AppointmentBooking.Wizard.Views.VisitStep.VisitTypeRulesField.prototype.template = "step/visit/fields/visit_type_rules";
AppointmentBooking.Wizard.Views.VisitStep.VisitTypeRulesField.prototype.className =
  "appointment-booking-wizard-visit-step-visit-type-rules-field";
